// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers';
import { EdgeWaypoint } from './edge-waypoint.js';
export class FlowEdge {
    bb = null;
    bb_pos = 0;
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsFlowEdge(bb, obj) {
        return (obj || new FlowEdge()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsFlowEdge(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new FlowEdge()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    id(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return this.bb.__string(this.bb_pos + offset, optionalEncoding);
    }
    source(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return this.bb.__string(this.bb_pos + offset, optionalEncoding);
    }
    sourceHandle(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 8);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    target(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 10);
        return this.bb.__string(this.bb_pos + offset, optionalEncoding);
    }
    targetHandle(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 12);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    waypoints(index, obj) {
        const offset = this.bb.__offset(this.bb_pos, 14);
        return offset ? (obj || new EdgeWaypoint()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + offset) + index * 4), this.bb) : null;
    }
    waypointsLength() {
        const offset = this.bb.__offset(this.bb_pos, 14);
        return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
    }
    static startFlowEdge(builder) {
        builder.startObject(6);
    }
    static addId(builder, idOffset) {
        builder.addFieldOffset(0, idOffset, 0);
    }
    static addSource(builder, sourceOffset) {
        builder.addFieldOffset(1, sourceOffset, 0);
    }
    static addSourceHandle(builder, sourceHandleOffset) {
        builder.addFieldOffset(2, sourceHandleOffset, 0);
    }
    static addTarget(builder, targetOffset) {
        builder.addFieldOffset(3, targetOffset, 0);
    }
    static addTargetHandle(builder, targetHandleOffset) {
        builder.addFieldOffset(4, targetHandleOffset, 0);
    }
    static addWaypoints(builder, waypointsOffset) {
        builder.addFieldOffset(5, waypointsOffset, 0);
    }
    static createWaypointsVector(builder, data) {
        builder.startVector(4, data.length, 4);
        for (let i = data.length - 1; i >= 0; i--) {
            builder.addOffset(data[i]);
        }
        return builder.endVector();
    }
    static startWaypointsVector(builder, numElems) {
        builder.startVector(4, numElems, 4);
    }
    static endFlowEdge(builder) {
        const offset = builder.endObject();
        builder.requiredField(offset, 4); // id
        builder.requiredField(offset, 6); // source
        builder.requiredField(offset, 10); // target
        return offset;
    }
    static createFlowEdge(builder, idOffset, sourceOffset, sourceHandleOffset, targetOffset, targetHandleOffset, waypointsOffset) {
        FlowEdge.startFlowEdge(builder);
        FlowEdge.addId(builder, idOffset);
        FlowEdge.addSource(builder, sourceOffset);
        FlowEdge.addSourceHandle(builder, sourceHandleOffset);
        FlowEdge.addTarget(builder, targetOffset);
        FlowEdge.addTargetHandle(builder, targetHandleOffset);
        FlowEdge.addWaypoints(builder, waypointsOffset);
        return FlowEdge.endFlowEdge(builder);
    }
}
//# sourceMappingURL=flow-edge.js.map